import "./src/styles/global.css"
import { wrapRootElement as wrap } from './root-wrapper';

export const wrapRootElement = wrap;